import {TimeagoIntl} from 'ngx-timeago';
import {strings as russianStrings} from 'ngx-timeago/language-strings/ru';

export class TimeAgoIntlRu extends TimeagoIntl {
  strings = russianStrings;
}
